var giphy_viewer_default = {
  "giphyWrapper": "gzUS2",
  "giphy_player": "QBrsh",
  "playIcon": "_6c5On",
  "gifRatio": "q5iLv"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
